type Mods = Record<string, boolean | string>;

export function classNames(
  s: string,
  mods: Mods = {},
  additional: string[] = []
): string {
  return [
    s,
    ...additional.filter(Boolean),
    ...Object.entries(mods)
      .filter(([className, value]) => Boolean(value))
      .map(([className]) => className),
  ].join(" ");
}
